import { createSelector } from 'reselect'
import whiteboardModes from 'helpers/enums/whiteboardModes'

const getWhiteboardData = state => state.whiteboardSession

const drawingIdSelector = createSelector(
	[ getWhiteboardData ],
	whiteboard => {

		const {phoenixSessionId, mode, slideId, id} = whiteboard
		return {
			sessionId: id,
			phoenixSessionId,
			mode,
			slideId: mode === whiteboardModes.ANNOTATE ? String(slideId) : '-1',
		}
	}
)

export default drawingIdSelector
